<div class="row mb-2">
  <div class="col-md-2">
    <select [(ngModel)]="searchBy" class="form-control">
      <option value="">Select Search By</option>
      <option value="packageID">Package ID</option>
      <option value="userId">User ID</option>
      <option value="senderMobile">Sender Mobile no</option>
      <option value="senderName">Sender Name</option>
      <option value="fromAddress">From Address</option>
    </select>
  </div>
  <div class="col-md-2">
    <input
      type="search"
      [(ngModel)]="searchText"
      class="form-control mb-2"
      placeholder="Search Text"
    />
  </div>
  <div class="col-md-2">
    <button
      (click)="search()"
      class="btn btn-primary btn-block"
      [disabled]="searchBy == ''"
    >
      Search <i class="fa fa-search"></i>
    </button>
  </div>

  <div class="col-md-6 m-0 text-end">
    <button
      (click)="exportToExcel()"
      style="margin-right: 5px !important"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Current Excel
    </button>
    <button
      (click)="getAllPackagess()"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export All Excel
    </button>
  </div>
</div>

<div class="main-card mb-3 card">
  <div class="card-header font-weight-B fs-1r">All Packages / Orders</div>
  <div class="table-responsive">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
      id="excel-table"
    >
      <thead>
        <tr class="align-middle">
          <!-- <th class="text-left" >#</th> -->
          <th>Package ID</th>
          <th>Sender Name</th>
          <th>Sender Mobile No.</th>
          <th>From Address</th>
          <th>Receiver Name</th>
          <th>Receiver Mobile No.</th>
          <th>To Address</th>
          <th>Created On</th>
          <th>Status</th>
          <th>City</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let data of allPackagesList
              | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  }
          "
        >
          <!-- <td class="text-left text-muted">#355</td> -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.packageID }}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.senderName }}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>

          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.senderMobile }}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.fromAddress }}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.receiverName }}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.receiverMobile }}</div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.toAddress }}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{
                      data.timestamp * 1000
                        | date : "dd MMM yyyy hh:mm a" : "en-IN"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading" *ngIf="data.status === 0">
                    Package Generated
                  </div>
                  <div class="widget-heading" *ngIf="data.status === 1">
                    Driver Accepted
                  </div>
                  <div class="widget-heading" *ngIf="data.status === 2">
                    Trip Started
                  </div>
                  <div class="widget-heading" *ngIf="data.status === 3">
                    Trip Complete
                  </div>
                  <div class="widget-heading" *ngIf="data.status === 4">
                    User cancelled
                  </div>
                  <div class="widget-heading" *ngIf="data.status === 5">
                    Driver cancelled
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">{{ data.city }}</div>
                  <!-- <div class="widget-subheading opacity-7">Web Developer</div> -->
                </div>
              </div>
            </div>
          </td>

          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-info dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Action
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li>
                  <a class="dropdown-item" (click)="routeViewDetails(data)"
                    >View Details <i class="fa fa-eye"></i
                  ></a>
                </li>
                <li>
                  <a class="dropdown-item" (click)="routeTrackPackage(data)"
                    >Track Package <i class="fa fa-map-marker"></i
                  ></a>
                </li>
                <li>
                  <a
                    class="dropdown-item"
                    (click)="editPackage(editModal, data)"
                    >Edit <i class="fa fa-pencil"></i
                  ></a>
                </li>
                <li>
                  <a class="dropdown-item" (click)="deletePackage(data)"
                    >Delete <i class="fa fa-trash"></i
                  ></a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>
      <div *ngIf="allPackagesList?.length == 0" class="text-center mt-5 mb-5">
        <span class="text-danger">Data Not found</span>
      </div>
    </table>
    <!-- <pagination-controls class="my-pagination" (pageChange)="gty((page = $event))"></pagination-controls> -->

    <ngb-pagination
      (pageChange)="gty((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>

<div class="card-body">
  <ng-template #editModal let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h5 class="modal-title">
        <i class="fa fa-pencil" aria-hidden="true"></i> Edit Package
      </h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <label for="">Package Id </label>
          <input
            type="text"
            [(ngModel)]="packageId"
            placeholder="Enter id"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-md-1"></div>
      </div>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <label for="">User Id </label>
          <input
            type="text"
            [(ngModel)]="senderId"
            placeholder="Enter id"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Sender Name : </label>
          <input
            type="text"
            [(ngModel)]="senderName"
            class="form-control"
            placeholder="Sender name"
          />
        </div>
        <div class="col-md-5">
          <label for="">Receiver Name : </label>
          <input
            type="text"
            [(ngModel)]="receiverName"
            class="form-control"
            placeholder="Receiver name"
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Sender Mobile No. : </label>
          <input
            type="text"
            [(ngModel)]="senderMobile"
            class="form-control"
            placeholder="Sender mobile no."
          />
        </div>
        <div class="col-md-5">
          <label for="">Receiver Mobile No. : </label>
          <input
            type="text"
            [(ngModel)]="receiverMobile"
            class="form-control"
            placeholder="Receiver mobile no."
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Sender Email : </label>
          <input
            type="email"
            [(ngModel)]="senderEmail"
            class="form-control"
            placeholder="Sender email"
          />
        </div>
        <div class="col-md-5">
          <label for="">Receiver Email : </label>
          <input
            type="email"
            [(ngModel)]="receiverEmail"
            class="form-control"
            placeholder="Receiver email"
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Sender Address : </label>
          <input
            type="text"
            (onAddressChange)="getSenderAddress($event)"
            ngx-google-places-autocomplete
            [(ngModel)]="senderAddress"
            placeholder="Sender address"
            class="form-control"
          />
        </div>
        <div class="col-md-5">
          <label for="">Receiver Address : </label>
          <input
            type="text"
            (onAddressChange)="getReceiverAddress($event)"
            ngx-google-places-autocomplete
            [(ngModel)]="receiverAddress"
            placeholder="Receiver address"
            class="form-control"
          />
        </div>
        <div class="col-md-1"></div>
      </div>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Sender Latitude : </label>
          <input
            type="text"
            [(ngModel)]="senderLatitude"
            class="form-control"
            [disabled]="true"
          />
        </div>
        <div class="col-md-5">
          <label for="">Receiver Latitude : </label>
          <input
            type="text"
            [(ngModel)]="receiverLatitude"
            class="form-control"
            [disabled]="true"
          />
        </div>
        <div class="col-md-1"></div>
      </div>
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Sender Longtitude : </label>
          <input
            type="text"
            [(ngModel)]="senderLongtitude"
            class="form-control"
            [disabled]="true"
          />
        </div>
        <div class="col-md-5">
          <label for="">Receiver Longtitude : </label>
          <input
            type="text"
            [(ngModel)]="receiverLongtitude"
            class="form-control"
            [disabled]="true"
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Shipment Type : </label>
          <select name="" id="" class="form-control" [(ngModel)]="shipmentType">
            <option value="">Select Good Type</option>
            <option value="Test">Test</option>
          </select>
        </div>
        <div class="col-md-5">
          <label for="">Package Description : </label>
          <input
            type="text"
            [(ngModel)]="packageDesc"
            class="form-control"
            placeholder="Package description"
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">No. of Packages : </label>
          <input
            type="text"
            [(ngModel)]="nosPackage"
            class="form-control"
            placeholder="Numbers of packages"
          />
        </div>
        <div class="col-md-5">
          <label for="">Price Package Delivery : </label>
          <input
            type="text"
            [(ngModel)]="packageDeliveryPrice"
            class="form-control"
            placeholder="Price package delivery"
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Weight : </label>
          <input
            type="text"
            [(ngModel)]="packageWeight"
            class="form-control"
            placeholder="Packages weight"
          />
        </div>
        <div class="col-md-5">
          <label for="">Distance : </label>
          <input
            type="text"
            [(ngModel)]="distance"
            class="form-control"
            placeholder="Distance"
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for="">Driver Tip : </label>
          <input
            type="text"
            [(ngModel)]="driverTip"
            class="form-control"
            placeholder="Driver tip"
          />
        </div>
        <div class="col-md-5">
          <label for="">Special Instructions : </label>
          <input
            type="text"
            [(ngModel)]="specialInstructions"
            class="form-control"
            placeholder="Special instructions"
          />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-2">
          <label for="">Send By SMS : </label> <br />
          <label class="switch">
            <input
              type="checkbox"
              (ngModelChange)="sendBySMS($event)"
              [(ngModel)]="isSendBySMS"
            />
            <span class="slider round"></span>
          </label>
        </div>
        <div class="col-md-3">
          <label for="">Send By EMAIL : </label><br />
          <label class="switch">
            <input
              type="checkbox"
              (ngModelChange)="sendByEMAIL($event)"
              [(ngModel)]="isSendByEMAIL"
            />
            <span class="slider round"></span>
          </label>
        </div>

        <div class="col-md-5">
          <label for="">Package Image : </label>
          <input type="file" placeholder="Select package image" />
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row text-center mt-3">
        <div class="col-md-12">
          <button
            (click)="updatePackage()"
            class="btn-wide mb-2 me-2 btn btn-primary"
            [disabled]="
              senderName == '' ||
              receiverName == '' ||
              senderMobile == '' ||
              shipmentType == '' ||
              receiverMobile == '' ||
              senderEmail == '' ||
              receiverEmail == '' ||
              senderAddress == '' ||
              receiverAddress == '' ||
              nosPackage == '' ||
              packageDeliveryPrice == '' ||
              packageWeight == '' ||
              distance == ''
            "
          >
            Update Package
          </button>
        </div>
      </div>
    </div>
    <!-- <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
            <button type="button" class="btn btn-primary">Save changes</button>
          </div> -->
  </ng-template>
  <!-- <button class="btn btn-primary" (click)="open(content5)">Launch demo modal</button> -->
</div>
